import MFA from './mfa';
import MemberEfileJwtService from './member-efile';
import OauthJwtService from './oauth';
import OrgUnitsJwtService from './org-units';
import Auth from './auth';
import Logs from './logs';
import AuditTrail from './audit-trail';
import ActivityLogs from './activity-logs';

import Search from './search';
import Settings from './settings';
import Dashboard from './dashboard';

import Users from './users';
import Policy from './policy';
import Resource from './resource';
import UserRoles from './user-roles';
import ResourceActions from './resource-actions';
import PermissionSchema from './permission-schema';

import MemberTypes from './member-types';
import MemberTitles from './member-titles';
import EducationJwtService from './education';
import SampleCSVFiles from './sample-csv-file';
import DepartmentsJwtService from "./departments";
import WorkHistoryJwtService from "./work-history";
import MemberStatusJwtService from "./member-status";
import UserEducationJwtService from './user-education';
import MemberDesignations from './member-designations';
import MemberProfilesJwtService from './member-profiles';
import StationsServedJwtService from "./stations-served";
import AdminApplicationsService from './admin-applications';
import ApiClientsJwtService from './api-clients';
import UserWorkHistoryJwtService from "./user-work-history";

import CSVImportsJwtServices from './csv-imports';

import ChurchMap from './church-map';

export default class MainJwtServices {
  axiosIns = null;

  jwtConfig = null;

  auth = null;

  users = null;

  search = null;

  policy = null;

  settings = null;

  resource = null;

  userRoles = null;

  resourceActions = null;

  permissionSchema = null;

  logs = null;

  auditTrail = null;

  activityLogs = null;

  sampleCSVFiles = null;

  memberTypes = null;

  memberTitles = null;

  memberDesignations = null;

  churchMap = null;

  departments = null;

  applications = null;

  apiClients = null;

  memberProfiles = null;

  csvImports = null;

  memberStatus = null;

  education = null;

  userEducation = null;

  memberEfile = null;

  oauth = null;

  orgUnits = null;

  workHistory = null;

  userWorkHistory = null;

  stationsServed = null;

  mfaService = null;

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;

    this.mfaService = new MFA(axiosIns, jwtConfig);
    this.auth = new Auth(axiosIns, jwtConfig);
    this.logs = new Logs(axiosIns, jwtConfig);
    this.auditTrail = new AuditTrail(axiosIns, jwtConfig);
    this.activityLogs = new ActivityLogs(axiosIns, jwtConfig);
    this.education = new EducationJwtService(axiosIns, jwtConfig);
    this.userEducation = new UserEducationJwtService(axiosIns, jwtConfig);
    this.memberEfile = new MemberEfileJwtService(axiosIns, jwtConfig);
    this.oauth = new OauthJwtService(axiosIns, jwtConfig);
    this.orgUnits = new OrgUnitsJwtService(axiosIns, jwtConfig);

    this.workHistory = new WorkHistoryJwtService(axiosIns, jwtConfig);
    this.stationsServed = new StationsServedJwtService(axiosIns, jwtConfig);
    this.userWorkHistory = new UserWorkHistoryJwtService(axiosIns, jwtConfig);

    this.users = new Users(axiosIns, jwtConfig);
    this.search = new Search(axiosIns, jwtConfig);
    this.dashboard = new Dashboard(axiosIns, jwtConfig);

    this.policy = new Policy(axiosIns, jwtConfig);
    this.settings = new Settings(axiosIns, jwtConfig);
    this.resource = new Resource(axiosIns, jwtConfig);
    this.userRoles = new UserRoles(axiosIns, jwtConfig);
    this.resourceActions = new ResourceActions(axiosIns, jwtConfig);
    this.permissionSchema = new PermissionSchema(axiosIns, jwtConfig);

    this.sampleCSVFiles = new SampleCSVFiles(axiosIns, jwtConfig);

    this.memberTypes = new MemberTypes(axiosIns, jwtConfig);
    this.memberTitles = new MemberTitles(axiosIns, jwtConfig);
    this.memberDesignations = new MemberDesignations(axiosIns, jwtConfig);
    this.memberProfiles = new MemberProfilesJwtService(axiosIns, jwtConfig);

    this.churchMap = new ChurchMap(axiosIns, jwtConfig);
    this.departments = new DepartmentsJwtService(axiosIns, jwtConfig);
    this.memberStatus = new MemberStatusJwtService(axiosIns, jwtConfig);
    this.applications = new AdminApplicationsService(axiosIns, jwtConfig);

    this.apiClients = new ApiClientsJwtService(axiosIns, jwtConfig);

    this.csvImports = new CSVImportsJwtServices(axiosIns, jwtConfig);
  }
}
